import { type SidebarItem } from '../App'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'

export const iconMap = {
  home: HomeOutlinedIcon,
  assetManagement: InsertDriveFileOutlinedIcon,
  configuration: SettingsOutlinedIcon,
  help: HelpOutlineIcon
}
export type IconKey = keyof typeof iconMap

// Add menu items for all the tiles here. The id should be home for the first menuitem.
export function getMenuItemsForSubApp (subAppId: string): SidebarItem[] {
  switch (subAppId) {
    case 'isense':
      return [
        { id: 'home', label: 'Home', icon: 'home', to: '/isense' },
        { id: 'assetManagement', label: 'Asset Management', icon: 'assetManagement', to: '/card' },
        { id: 'help', label: 'Help', icon: 'help', to: '' }
      ]
    case 'datapub':
      return [
        { id: 'home', label: 'Home', icon: 'home', to: '/datapub' },
        { id: 'connectionSettings', label: 'Connection Settings', icon: 'configuration', to: '/configuration-dashboard' },
        { id: 'help', label: 'Help', icon: 'help', to: '' }
      ]
    default:
      return []
  }
}
